import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {setWizardPopupItem, setWizardPopupOpened, updateWizardList} from "../wizardActions";
import SvgIcons from "../../Icons/SvgIcons";
import {wizardItemInterface} from "../WizardItem/wizardItemInterface";
import PropTypes from "prop-types";
import {WIZARD_POPUP_TYPES} from "../wizardReducer";

const WizardNodeStart = (props) => {

  const {setWizardPopupOpened, wizardActiveItem, setWizardPopupItem} = props;

  const onEditClick = () => {
    setWizardPopupOpened(true, WIZARD_POPUP_TYPES.start);
    setWizardPopupItem(wizardActiveItem, {
      title: wizardActiveItem.startTitle || "",
      description: wizardActiveItem.startDescription || "",
      skipStartStep: wizardActiveItem.skipStartStep || false,
    });
  }

  return (
    <Fragment>
      Start
      <button className="wizard-group__icon ui-icon-gray2 ui-icon-gray2--white" onClick={onEditClick}>
        {SvgIcons.edit}
      </button>
    </Fragment>
  )
};

WizardNodeStart.propTypes = {
  wizardActiveItem: PropTypes.shape(wizardItemInterface).isRequired,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  updateWizardList,
  setWizardPopupOpened,
  setWizardPopupItem,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardNodeStart)
)
